import { get, post, axios } from './baseAxios';
import { API_ITEM_INFO } from '../utils/urls';

const url = API_ITEM_INFO;
export const getItemInfo = (id) => get(`${url}/${id}`);

export const getItemInfos = (params) => get(url, { params });

export const updateItemInfo = (request) => post(url, request);

export const createItemInfo = (request) => post(url, request);

export const deleteItemInfo = (id) => axios.delete(`${url}/${id}`);

export const checkWebRotateUsage = (code) => get(`${url}/web-rotate/${code}`);
